/**
 * Helpers de presentación compartidos entre la lista de candidatos
 * (`ScoutDetail`) y la página de detalle (`ScoutCandidateDetail`). Ver
 * docs/scout-plan/04.
 */
import type { ScoutCandidate, ScoutResult } from '../../api/admin/scout.js';

export function statusPill(status: ScoutCandidate['status']): string {
  if (status === 'evaluated') return 'pill pill-good';
  if (status === 'completed') return 'pill pill-level-1';
  return 'pill';
}

export function recPill(rec: ScoutResult['recommendation']): string {
  if (rec === 'advance') return 'pill pill-level-0';
  if (rec === 'reject') return 'pill pill-level-3';
  return 'pill pill-level-2';
}

export function recLabel(rec: ScoutResult['recommendation']): string {
  if (rec === 'advance') return 'Avanzar';
  if (rec === 'reject') return 'Descartar';
  return 'Dudoso';
}

/** Tooltip compacto con el desglose de scores por dimensión. */
export function scoresTitle(result: ScoutResult): string {
  const dims = Object.entries(result.scores)
    .map(([k, v]) => `${k}: ${v.score}/5`)
    .join(' · ');
  return dims || 'sin desglose';
}

/**
 * Key de la rúbrica (ej. `ia_agentica`) → label legible. El label "lindo" vive
 * en la guía `.md` del rol y no viaja en el resultado; acá nos alcanza con
 * normalizar la key.
 */
export function dimLabel(key: string): string {
  const spaced = key.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function fmt(iso: string): string {
  return new Date(iso).toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' });
}
